import { Image } from "@/components/image";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  forDirectors?: boolean;
  nameClassName?: string;
}

export const Logo = (props: LogoProps) => (
  <div className="flex items-center gap-4 text-sm">
    <Image
      src="/img/oscar-logo-filled-square.svg"
      alt="OSCAR Logo"
      width={75}
      height={75}
      className={cn(
        "rounded-lg",
        props.className,
        props.forDirectors && "saturate-0"
      )}
      priority
    />
    <div className={props.nameClassName}>
      <h4 className="text-lg font-semibold tracking-tight whitespace-nowrap">
        OSCAR Radio
      </h4>
      {props.forDirectors && <p>For Directors</p>}
    </div>
  </div>
);
